'use strict'

const service = config.VUE_APP_service_licenze || ''
const sellogicKey = config.sellogic_key || ''

async function updateAcquistoFattureCliente(apikey, acquistoFatture) {
  try {
    const data = {
      apikey,
      acquistoFatture
    }
    const response = await fetch(`${service}/acquisti/fatture`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (err) {
    return {}
  }
}

async function deleteAcquistoFattureCliente(apikey, codiceAcquistoFatture) {
  try {
    const data = {
      apikey,
      codiceAcquistoFatture
    }
    const response = await fetch(`${service}/acquisti/fatture`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (err) {
    return {}
  }
}

async function elencoAcquistiFattureCliente(apikey) {
  try {
    const response = await fetch(`${service}/acquisti/fatture/${apikey}`)
    return await response.json()
  } catch (err) {
    return {}
  }
}

async function updateAcquistoMessaggiCliente(apikey, acquistoMessaggi) {
  try {
    const data = {
      apikey,
      acquistoMessaggi
    }
    const response = await fetch(`${service}/acquisti/messaggi`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (err) {
    return {}
  }
}

async function deleteAcquistoMessaggiCliente(apikey, codiceAcquistoMessaggi) {
  try {
    const data = {
      apikey,
      codiceAcodiceAcquistoMessaggicquistoFatture
    }
    const response = await fetch(`${service}/acquisti/messaggi`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (err) {
    return {}
  }
}

async function elencoAcquistiMessaggiCliente(apikey) {
  try {
    const response = await fetch(`${service}/acquisti/messaggi/${apikey}`)
    return await response.json()
  } catch (err) {
    return {}
  }
}

export default {
  updateAcquistoFattureCliente,
  elencoAcquistiFattureCliente,
  deleteAcquistoFattureCliente,
  updateAcquistoMessaggiCliente,
  elencoAcquistiMessaggiCliente,
  deleteAcquistoMessaggiCliente
}
